import * as React from "react";
import { SVGProps } from "react";

const BronzeTierLarge = (
  props: SVGProps<SVGSVGElement> & { bgColor?: string }
) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 73 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M61.9929 36.2664L61.9929 40.3961C61.9929 54.5323 50.6362 65.8889 36.5 65.8889C22.3638 65.8889 11.0071 54.5323 11.0071 40.3961L11.0071 36.2664H61.9929Z"
      fill="#975E37"
    />
    <path
      d="M54.75 54.75C44.6708 64.8292 28.3292 64.8292 18.25 54.75C8.1708 44.6708 8.1708 28.3292 18.25 18.25C28.3292 8.1708 44.6708 8.1708 54.75 18.25C64.8292 28.3292 64.8292 44.6708 54.75 54.75Z"
      fill="#E59F6E"
    />
    <path
      d="M48.6399 48.6411C41.9352 55.3457 31.0648 55.3457 24.3601 48.6411C17.6555 41.9364 17.6555 31.066 24.3601 24.3613C31.0648 17.6567 41.9352 17.6567 48.6399 24.3613C55.3445 31.066 55.3445 41.9364 48.6399 48.6411Z"
      fill="#F19520"
    />
    <path
      d="M10.6906 36.4205C10.6906 50.7311 22.1873 62.2278 36.4979 62.2278C47.4318 62.2278 56.7578 55.4745 60.5364 45.9073C52.2556 47.2741 41.6432 45.6661 31.2721 40.6012C23.4736 36.8225 17.2027 31.8379 12.7809 26.4514C11.4141 29.5868 10.6906 32.8831 10.6906 36.4205Z"
      fill="#E59F6E"
    />
    <path
      d="M48.6399 48.6411C41.9352 55.3457 31.0648 55.3457 24.3601 48.6411C17.6555 41.9364 17.6555 31.066 24.3601 24.3613C31.0648 17.6567 41.9352 17.6567 48.6399 24.3613C55.3445 31.066 55.3445 41.9364 48.6399 48.6411Z"
      fill="#C78557"
    />
    <path
      d="M22.3482 26.6919C25.0816 24.7624 28.4583 23.6369 32.0761 23.7173C41.5629 23.7173 49.2006 31.3549 49.2006 40.8417C49.2006 44.3792 48.075 47.7558 46.2259 50.5697C50.7281 47.5146 53.7028 42.2888 53.6224 36.4199C53.6224 26.9331 45.9847 19.2955 36.4979 19.2955C30.7094 19.2955 25.4836 22.2701 22.3482 26.6919Z"
      fill="#975E37"
    />
    <path
      opacity="0.2"
      d="M36.5205 19.2844C33.1924 19.2843 30.4945 17.3499 30.4946 14.9638C30.4946 12.5776 33.1926 10.6433 36.5206 10.6434C39.8487 10.6434 42.5466 12.5778 42.5466 14.964C42.5465 17.3501 39.8486 19.2844 36.5205 19.2844Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M36.5205 62.2163C33.1924 62.2162 30.4945 60.2818 30.4946 57.8957C30.4946 55.5095 33.1926 53.5752 36.5206 53.5752C39.8487 53.5753 42.5466 55.5097 42.5466 57.8959C42.5465 60.282 39.8486 62.2163 36.5205 62.2163Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M36.4895 14.7463C34.9197 14.7463 33.6471 13.83 33.6471 12.6997C33.6471 11.5694 34.9197 10.6532 36.4896 10.6532C38.0594 10.6532 39.332 11.5695 39.332 12.6998C39.332 13.8301 38.0594 14.7464 36.4895 14.7463Z"
      fill="white"
    />
    <path
      d="M43.6144 36.7839C44.0282 37.1878 44.0416 37.849 43.6445 38.2693L36.9075 45.4C36.4895 45.8424 35.7856 45.8424 35.3676 45.4L28.6306 38.2693C28.2335 37.849 28.2469 37.1878 28.6607 36.7839L35.3977 30.2085C35.8092 29.8069 36.4659 29.8069 36.8774 30.2085L43.6144 36.7839Z"
      fill="url(#paint0_radial_6380_400)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_6380_400"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-6.87789 17.2308 -16.9781 -6.80548 38.5503 30.9998)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#FFE1CC" />
      </radialGradient>
    </defs>
  </svg>
);
export default BronzeTierLarge;
